import { axiosPrivate } from 'shared/api';
import { BaseService } from 'shared/services/BaseService';
import { IMedicalServiceEtlField } from '../types';

class MedicalServiceEtlFieldService extends BaseService<IMedicalServiceEtlField> {
  constructor() {
    super('medical-service-etl-fields');
    this.canDelete = true;
  }
  canBulkDelete = true;

  getChoices = async () => {
    const res = await axiosPrivate.get(`${this.modulePrefix}/get-choices/`);
    return res;
  };
}

export const medicalServiceEtlFieldService = new MedicalServiceEtlFieldService();
